import React from 'react';
import { AgFinancingCreditApprovalStatus, Phase2 } from '@indigo-ag/schema';
import { Tag, TagProps } from '@indigo-ag/component-module';

import i18next from 'core/i18n';
import { text } from 'shared';

const creditStatusLabelMap: Record<AgFinancingCreditApprovalStatus, string> = {
  [AgFinancingCreditApprovalStatus.IN_PROGRESS]: i18next.t('in_process'),
  [AgFinancingCreditApprovalStatus.CREDIT_ANALYST_APPROVED]: i18next.t('approved'),
  [AgFinancingCreditApprovalStatus.CREDIT_SUPERVISOR_APPROVED]: i18next.t('approved'),
  [AgFinancingCreditApprovalStatus.CREDIT_MANAGER_APPROVED]: i18next.t('approved'),
  [AgFinancingCreditApprovalStatus.COMMERCIAL_DIRECTOR_APPROVED]: i18next.t('approved'),
  [AgFinancingCreditApprovalStatus.FINANCE_DIRECTOR_APPROVED]: i18next.t('approved'),
  [AgFinancingCreditApprovalStatus.DENIED]: i18next.t('denied'),
  [AgFinancingCreditApprovalStatus.WAITING_CREDIT_MANAGER_DECISION]: i18next.t('escalated')
};

const creditStatusVariantMap: Record<AgFinancingCreditApprovalStatus, TagProps['variant']> = {
  [AgFinancingCreditApprovalStatus.IN_PROGRESS]: 'info',
  [AgFinancingCreditApprovalStatus.CREDIT_ANALYST_APPROVED]: 'success',
  [AgFinancingCreditApprovalStatus.CREDIT_SUPERVISOR_APPROVED]: 'success',
  [AgFinancingCreditApprovalStatus.CREDIT_MANAGER_APPROVED]: 'success',
  [AgFinancingCreditApprovalStatus.COMMERCIAL_DIRECTOR_APPROVED]: 'success',
  [AgFinancingCreditApprovalStatus.FINANCE_DIRECTOR_APPROVED]: 'success',
  [AgFinancingCreditApprovalStatus.DENIED]: 'error',
  [AgFinancingCreditApprovalStatus.WAITING_CREDIT_MANAGER_DECISION]: 'warning'
};

interface CreditApprovalStatusTagProps {
  status: Phase2['creditApprovalStatus'];
}

export const CreditApprovalStatusTag: React.FunctionComponent<CreditApprovalStatusTagProps> = ({ status }) => {
  if (!status) {
    return null;
  }

  return <Tag label={text.toTitleCase(creditStatusLabelMap[status])} variant={creditStatusVariantMap[status]} />;
};
